// src/config.js
// export const ROOT = 'localhost';
// export const DOMAIN = 'http://localhost';
// export const API = 'http://localhost/api';

export const ROOT = 'modamixtrends.com';
export const DOMAIN = 'https://modamixtrends.com';
export const API = 'https://modamixtrends.com/api';

